import { FAMILIES_PATH, PAYMENTS_PATH, RETRY_KIND, URSSAF_RETRY_PARAM } from '../../constants/urssafStatus';

const ids = (raw) => (raw || '').split(',').map(Number).filter((id) => Number.isInteger(id) && id > 0);

const paymentsLink = (familyId, lessonIds, param) => `${PAYMENTS_PATH}?${new URLSearchParams({
  [URSSAF_RETRY_PARAM.FAMILY]: String(familyId), [param]: lessonIds.join(','),
})}`;

/** URS2 — inbox « Réessayer »: demand → payment form (modal reopens, proposals recomputed);
 *  registration → the registration modal again. */
export function retryLink(familyId, lessonIds, kind = RETRY_KIND.DEMAND) {
  if (kind === RETRY_KIND.REGISTRATION) {
    return `${FAMILIES_PATH}?${new URLSearchParams({ [URSSAF_RETRY_PARAM.REGISTER]: String(familyId) })}`;
  }
  return paymentsLink(familyId, lessonIds, URSSAF_RETRY_PARAM.LESSONS);
}

/** URS2 — « Payer par un autre moyen »: payment form, family + these lessons selected, no auto-open. */
export const payLink = (familyId, lessonIds) => paymentsLink(familyId, lessonIds, URSSAF_RETRY_PARAM.PAY_LESSONS);

/** {familyId, lessonIds, autoOpen} or null. autoOpen = reopen the URSSAF modal (retry link). */
export function parseRetryLink(searchParams) {
  const familyId = Number(searchParams.get(URSSAF_RETRY_PARAM.FAMILY));
  const retry = ids(searchParams.get(URSSAF_RETRY_PARAM.LESSONS));
  const lessonIds = retry.length ? retry : ids(searchParams.get(URSSAF_RETRY_PARAM.PAY_LESSONS));
  return familyId > 0 && lessonIds.length ? { familyId, lessonIds, autoOpen: retry.length > 0 } : null;
}

/** Family id from the registration retry link, or null. */
export function parseRegisterLink(searchParams) {
  const familyId = Number(searchParams.get(URSSAF_RETRY_PARAM.REGISTER));
  return familyId > 0 ? familyId : null;
}

/** Smallest oldest-first prefix holding every retry lesson; null when one is no longer selectable. */
export function retryPrefix(selectableLessons, lessonIds) {
  const indexes = lessonIds.map((id) => selectableLessons.findIndex((l) => l.lesson_id === id));
  return indexes.every((i) => i >= 0) ? Math.max(...indexes) + 1 : null;
}
